import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import rootReducer from './_reducers';
import { sessionDebugMiddleware } from './middleware/session-debug.middleware';
const logger = createLogger();

let middleware = [];

// Always include session debug middleware (it's self-disabling based on config)
middleware = [...middleware, thunk, sessionDebugMiddleware];

if (process.env.NODE_ENV === 'development') {
  middleware = [...middleware, logger];
}

export const store = createStore(rootReducer, applyMiddleware(...middleware));
